import type React from "react";
import type { T_Interval } from "./non-draggable-stock-price-chart";
import { cn } from "@lattice/frontend/lib/utils/ui";

export default function IntervalToggle({
  interval,
  setInterval,
  className,
}: {
  interval: T_Interval;
  setInterval: React.Dispatch<React.SetStateAction<T_Interval>>;
  className?: string;
}) {
  return (
    <div className={cn(`flex justify-center my-4`, className)}>
      <div className="bg-grey-7 rounded-lg p-2 border border-[#131314] inline-flex">
        <div className="flex flex-wrap justify-center gap-1">
          {(
            [
              "1D",
              "1W",
              "1M",
              "6M",
              "1Y",
              "5Y",
              "MAX",
            ] as const satisfies readonly T_Interval[]
          ).map((int) => (
            <button
              key={int}
              className={`rounded-md px-4 py-2 text-sm font-medium cursor-pointer transition-all ${
                int === interval
                  ? "bg-[#D4D4D4] text-black shadow-sm"
                  : "text-muted-foreground hover:text-foreground hover:bg-white/5"
              }`}
              onClick={() => setInterval(int)}
            >
              {int}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
